import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=957d046e&scoped=true&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ProductBreadcrumbs.vue?vue&type=style&index=0&id=957d046e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957d046e",
  null
  
)

export default component.exports